export default "__VITE_ASSET__581ea662__"